import styled from "styled-components";
import { ThemePalette } from "./theme";

export const StyledLinkAnimation = styled.div<{ hovercolor: string }>`
  width: 100vw;
  .nav-animate {
    --list-top-bottom-padding: 0.3rem;
    --list-left-padding: 3rem;
    --list-left-padding-animation-offset: 1rem;

    list-style: none;
    padding: unset;

    .nav-item {
      position: relative;
      width: 12rem;
      cursor: pointer;

      &.long {
        width: 15rem;
      }

      &.selected {
        background-color: ${ThemePalette.colorWhite};
        color: black;
      }

      &:not(.selected) {
        &::before {
          content: "";
          position: absolute;
          bottom: 0;
          display: block;
          background-color: ${(props) => props.hovercolor};
          width: calc(100% - var(--list-left-padding));
          height: 100%;
          border-radius: 100rem;
          opacity: 0;
          transition: all 0.2s ease;
        }

        & a {
          transition: all 0.2s ease;
        }

        &:hover {
          & a {
            // padding-left: var(--list-left-padding-animation-offset);
            color: white;
            transition: all 0.2s ease;
          }
          background-color: ${(props) => props.hovercolor};

          &::before {
            height: 10%;
            /* opacity: 0.6;
            transition: all 0.2s ease; */
          }
        }
      }
    }
  }
`;
